import useSWR from 'swr'
import { fetchBackfill, startBackfill, type BackfillState } from '@/lib/api/sources.ts'

export function isBackfillActive(state: BackfillState | null | undefined): boolean {
  return state?.job?.state === 'queued' || state?.job?.state === 'running'
}

/**
 * The pipeline's period import (#231): polls while a job runs, the way
 * `useSyncRun` does for a sweep, and carries the covered interval the header
 * shows. Mounted per pipeline; a native pipeline answers no job and no
 * interval, and renders nothing for it.
 */
export function usePipelineBackfill(pipelineId: string, enabled = true) {
  const { data, mutate } = useSWR(
    enabled ? `/pipelines/${pipelineId}/backfill` : null,
    () => fetchBackfill(pipelineId),
    { refreshInterval: (latest) => (isBackfillActive(latest) ? 2000 : 0) },
  )

  return {
    state: data ?? null,
    active: isBackfillActive(data),
    refresh: mutate,
    async start(range: { from: Date; to: Date }) {
      const next = await startBackfill(pipelineId, range)
      await mutate(next, { revalidate: false })
      return next
    },
  }
}
